import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-internal-error',
  imports: [MatButtonModule],
  templateUrl: './internal-error.component.html',
  styleUrl: './internal-error.component.scss',
})
export class InternalErrorComponent {}
